var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-form-base',{attrs:{"id":_vm.id2,"label":_vm.label,"label-width":_vm.labelWidth,"label-position":_vm.labelPosition,"prepend-icon":_vm.prependIcon,"append-icon":_vm.appendIcon}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }